<template>
  <div class="editor-wrapper">
    <div :id="editorId"></div>
  </div>
</template>

<script>
import Editor from 'wangeditor'
import 'wangeditor/release/wangEditor.min.css'
import { oneOf } from '@/libs/tools'
export default {
  name: 'Editor',
  props: {
    value: {
      type: String,
      default: ''
    },
    /**
     * 绑定的值的类型, enum: ['html', 'text']
     */
    valueType: {
      type: String,
      default: 'html',
      validator: (val) => {
        return oneOf(val, ['html', 'text'])
      }
    },
    /**
     * @description 设置change事件触发时间间隔
     */
    changeInterval: {
      type: Number,
      default: 200
    },
    /**
     * @description 是否开启本地存储
     */
    cache: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    editorId () {
      return `editor${this._uid}`
    }
  },
  methods: {
    setHtml (val) {
      this.editor.txt.html(val)
    }
  },
  mounted () {
    this.editor = new Editor(`#${this.editorId}`)
    this.editor.customConfig.onchange = (html) => {
      this.isChange = true
      let text = this.editor.txt.text()
      this.$emit('input', this.valueType === 'html' ? html : text)
      this.$emit('on-change', html, text)
    }
    this.editor.customConfig.onchangeTimeout = this.changeInterval
    // create这个方法一定要在所有配置项之后调用
    this.editor.create()
    this.editor.txt.html(this.value)

    document.onkeydown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        // 触发save事件
        this.$emit('save', this.editor.txt.html())
        // 阻止默认事件
        e.preventDefault()
      }
    }
  },
  watch: {
    value () {
      // this.editor.txt.html(this.content)
      // 这是为了解决输入时光标乱跳
      // content为编辑框输入的内容，这里我监听了一下值，
      // 当父组件调用得时候，如果给content赋值了，子组件将会显示父组件赋给的值
      if (!this.isChange) {
        this.editor.txt.html(this.value)
      }
      this.isChange = false
    }
  }
}
</script>

<style lang="less">
.editor-wrapper *{
  z-index: 100 !important;
}
</style>
